import * as Scrivito from "scrivito";

export const MediaContainer = Scrivito.connect(({ image, lazy = "true" }) => (
  <Scrivito.ImageTag
    className="page-header-widget__image img-fluid"
    content={image}
    width={image.metadata().get("width")}
    height={image.metadata().get("height")}
    alt={image.get("alternativeText") || ""}
    loading={lazy ? "lazy" : "eager"}
    fetchPriority={!lazy ? "high" : undefined}
  />
));
